import { FRETS_0_12, masteryAchievement } from './helpers';

export default masteryAchievement({
  id: 'string-6-master',
  title: 'String 6 master',
  description: `You know every natural note on the low E string, ${FRETS_0_12}.`,
  order: 10,
  skillId: 'F2.string6-naturals',
});
